/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import type { JSX, ReactNode } from 'react';

interface PageHeaderProps {
  readonly title: string;
  readonly subtitle?: string | undefined;
  readonly action?: ReactNode;
}

/** Consistent page title block + optional right-aligned action (e.g. "Add"). */
export function PageHeader({ title, subtitle, action }: PageHeaderProps): JSX.Element {
  return (
    <header className="mb-6 flex flex-wrap items-center justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">{title}</h1>
        {subtitle !== undefined && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {action}
    </header>
  );
}
